import { Search } from 'lucide-react'

// Inline search input — leading magnifier + the touch-friendly `.field` base
// (≥16px, so iOS doesn't zoom on focus). Shared by the screens that reveal a
// search row from their TopBar (Partidos / Lugares / Contactos) so the affordance
// stays identical everywhere. `type=search` gives the on-screen "search" key +
// the native clear control.
export function SearchField({
  value,
  onChange,
  placeholder,
  autoFocus,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoFocus?: boolean
}) {
  return (
    <div className="relative">
      <Search
        size={18}
        className="absolute left-3 top-1/2 -translate-y-1/2 z-10 text-[color:var(--fg-faint)] pointer-events-none"
      />
      <input
        autoFocus={autoFocus}
        type="search"
        inputMode="search"
        enterKeyHint="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="field field--icon"
      />
    </div>
  )
}
